import type { Messages } from '../catalogue.en'

export const imaging: Partial<Messages> = {
  'imaging.title': 'Медицинские изображения',
  'imaging.subtitle': 'Размещённые исследования КТ и МРТ, доступные лечащей команде пациента.',
  'imaging.tableLabel': 'Исследования пациента',
  'imaging.add': 'Добавить исследование',
  'imaging.folder': 'Папка',
  'imaging.folderUnfiled': 'Без папки',
  'imaging.forbidden': 'Исследования недоступны этой учётной записи',
  'imaging.forbiddenDetail': 'Клиника не предоставила доступ к размещённым исследованиям.',
  'imaging.movedTitle': 'Исследования — часть файлов пациента',
  'imaging.movedDetail': 'Исследования и импорты стали строками таблицы файлов. Отфильтруйте столбец «Содержимое» по значению «Медицинские изображения», чтобы увидеть только их.',
  'imaging.loading': 'Загрузка исследований…',
  'imaging.loadFailed': 'Не удалось загрузить исследования.',
  'imaging.retry': 'Повторить',
  'imaging.empty': 'Нет размещённых исследований',
  'imaging.emptyDetail': 'Здесь появятся проверенные исследования КТ и МРТ, импортированные для этого пациента.',
  'imaging.noMatches': 'Нет исследований, соответствующих текущим фильтрам',
  'imaging.columnStudy': 'Исследование',
  'imaging.columnDate': 'Дата исследования',
  'imaging.columnModality': 'Тип',
  'imaging.columnSeries': 'Серии',
  'imaging.columnImages': 'Изображения',
  'imaging.columnSource': 'Источник',
  'imaging.columnStatus': 'Статус',
  'imaging.columnActions': 'Действия',
  'imaging.studyUntitled': 'Исследование',
  'imaging.viewerOpen': 'Открыть просмотр',
  'imaging.viewerOpenNamed': 'Открыть просмотр исследования «{name}»',
  'imaging.viewerOpening': 'Открытие просмотра…',
  'imaging.viewerUnavailable': 'Не удалось открыть просмотр. Повторите попытку.',
  'imaging.viewerContinue': 'Перейти к просмотру',
  'imaging.viewerPopupBlocked': 'Браузер заблокировал новую вкладку просмотра. Перейдите по этой ссылке.',
  'imaging.viewerPending': 'Ожидает проверки архива',
  'imaging.statusWithdrawn': 'Отозвано — внесено ошибочно',

  'imaging.studyPanelTitle': 'Свойства исследования',
  'imaging.studyStorage': 'Хранение и сроки',
  'imaging.studyRetention': 'Политика хранения',
  'imaging.retentionIndefinite': 'Хранится до удаления',
  'imaging.retentionUntil': 'Хранится до {date}',
  'imaging.studyRegistered': 'Зарегистрировано',
  'imaging.studyIdentifier': 'UID исследования',
  'imaging.purgeLabel': 'Удаление',
  'imaging.purge.queued': 'В очереди на безвозвратное удаление',
  'imaging.purge.purged': 'Безвозвратно удалено',
  'imaging.purge.failed': 'Безвозвратное удаление не выполнено',

  'imaging.studyComment': 'Комментарий',
  'imaging.noComment': 'Комментарий не записан',
  'imaging.editMetadata': 'Изменить сведения',
  'imaging.editFormLabel': 'Изменение сведений о {name}',
  'imaging.editTitle': 'Заголовок',
  'imaging.editTitleHint': 'Оставьте пустым, чтобы показать описание из архива.',
  'imaging.editComment': 'Комментарий',
  'imaging.editSave': 'Сохранить сведения',
  'imaging.editSaving': 'Сохранение',
  'imaging.editCancel': 'Отмена',
  'imaging.editStaleRevision': 'Пока вы редактировали, эти сведения изменил кто-то другой.',
  'imaging.editStaleRevisionDetail':
    'Загрузите сохранённую редакцию, чтобы увидеть, что хранится сейчас, затем примените к ней своё изменение.',
  'imaging.editReload': 'Загрузить сохранённую редакцию',
  'imaging.editReloadFailed': 'Не удалось загрузить сохранённую редакцию. Ваши изменения на месте.',
  'imaging.editInvalid': 'Проверьте сведения и попробуйте снова.',
  'imaging.editForbidden': 'У вас нет прав на изменение этого исследования.',
  'imaging.editGone': 'Это исследование больше недоступно.',
  'imaging.editSessionEnded': 'Ваш сеанс завершён. Войдите снова, чтобы продолжить.',
  'imaging.editUnavailable': 'Сейчас не удалось сохранить сведения. Попробуйте позже.',
  'imaging.editUnsavedTitle': 'Несохранённые сведения',
  'imaging.editUnsavedDetail': 'Вы изменили сведения об этом исследовании и не сохранили их.',
  'imaging.editKeepEditing': 'Продолжить редактирование',
  'imaging.editDiscard': 'Отменить изменения',
  'imaging.unsavedIntent': 'Сведения об исследовании',

  'imaging.linkUnknownRecord': 'Запись',
  'imaging.linksTitle': 'Записи ЭМК',
  'imaging.linksNone': 'С этим исследованием не связано ни одной записи ЭМК.',
  'imaging.linksAdd': 'Добавить запись ЭМК',
  'imaging.linkPick': 'Связать с записью…',
  'imaging.linksUnavailable': 'Связи этого исследования с записями недоступны.',
  'imaging.linkedAt': 'Связано {date}',
  'imaging.unlinkAction': 'Отвязать',
  'imaging.unlinkRecord': 'Отвязать {name}',
  'imaging.linkWorking': 'Выполняется',
  'imaging.linkAddTitle': 'Связать с записью',
  'imaging.linkRecordsLoading': 'Загрузка записей',
  'imaging.linkRecordsUnavailable': 'Список записей недоступен',
  'imaging.linkNoneOnThisPage': 'На этой странице больше записей нет. Покажите более старые записи, чтобы найти ещё.',
  'imaging.linkNoneAvailable': 'У этого пациента нет других финальных записей для связывания.',
  'imaging.linkAction': 'Связать',
  'imaging.linkRecord': 'Связать с {name}',
  'imaging.recordFinalizedAt': 'Финализирована',
  'imaging.recordStatusFinal': 'Финальная',
  'imaging.linkMoreRecords': 'Показать более старые записи',
  'imaging.linkForbidden': 'У вас нет прав на изменение связей этого исследования с записями.',
  'imaging.linkGone': 'Не удалось изменить эту связь. Исследование или запись больше недоступны.',
  'imaging.linkUnavailable': 'Сейчас не удалось изменить связь с записью. Попробуйте позже.',

  'imaging.exportReadingInventory': 'Читаем метаданные исследования',
  'imaging.exportReadingSources': 'Читаем выбранные исходные объекты',
  'imaging.exportRendering': 'Кодируем DICOM-объекты',
  'imaging.exportPackaging': 'Подготавливаем ZIP-архив и индекс носителя',
  'imaging.exportUploading': 'Сохраняем архив экспорта',
  'imaging.exportMetadataCount': 'Прочитаны метаданные объектов этой серии: {count}',
  'imaging.exportObjectCount': 'Подготовлено DICOM-объектов: {count}',
  'imaging.exportCancelPreparationHint': 'Отменяем после завершения проверки выбранных данных на сервере. Экспорт не останется в очереди.',
  'imaging.exportTitle': 'Экспорт DICOM-исследования',
  'imaging.exportSubtitle': 'Выберите серии, диапазоны кадров, область и кодирование для офлайн-просмотрщика принимающего врача.',
  'imaging.exportLoading': 'Читаем состав серий и кадров…',
  'imaging.exportInventoryFailed': 'Не удалось получить состав исследования. Закройте панель и попробуйте снова.',
  'imaging.exportForbidden': 'У вас нет прав на экспорт этого исследования.',
  'imaging.exportStudyUnavailable': 'Это исследование больше недоступно для экспорта.',
  'imaging.exportSourceChanged': 'Исследование изменилось после загрузки параметров. Закройте панель и снова откройте экспорт.',
  'imaging.exportEmpty': 'В исследовании нет поддерживаемых серий изображений CT или MR для экспорта.',
  'imaging.exportFormat': 'Формат результата',
  'imaging.exportTransferSyntax': 'Синтаксис передачи',
  'imaging.exportTransferSyntaxHint': 'Выберите кодирование, которое поддерживает офлайн-просмотрщик врача.',
  'imaging.exportLossyQuality': 'Качество JPEG (1–100)',
  'imaging.exportLayout': 'Структура DICOM-объектов',
  'imaging.exportLayoutSource': 'Сохранить структуру источника',
  'imaging.exportLayoutClassic': 'Классическая — один instance на кадр',
  'imaging.exportLayoutEnhanced': 'Enhanced — много кадров в instance',
  'imaging.exportDicomdir': 'Добавить индекс носителя DICOMDIR',
  'imaging.exportSeries': 'Серии и кадры',
  'imaging.exportSeriesSelected': 'Выбрано: {count}',
  'imaging.exportSelectAll': 'Выбрать все',
  'imaging.exportSelectNone': 'Снять выбор',
  'imaging.exportSeriesFacts': '{modality} · позиций по порядку: {count}',
  'imaging.exportSourceObjects': 'Объекты источника',
  'imaging.exportPixelMatrix': 'Матрица пикселей',
  'imaging.exportPixelMatrixValue': '{rows} × {columns}',
  'imaging.exportStoredLayout': 'Исходная структура',
  'imaging.exportSourceClassic': 'Классические instances',
  'imaging.exportSourceMultiframe': 'Многокадровый instance',
  'imaging.exportSourceState': 'Состояние источника',
  'imaging.exportSourceOriginal': 'Оригинальный',
  'imaging.exportSourceDerived': 'Уже производный',
  'imaging.exportSpacing': 'Шаг плоскостей',
  'imaging.exportSpacingRegular': 'Регулярный',
  'imaging.exportSpacingIrregular': 'Нерегулярный',
  'imaging.exportSpacingUnknown': 'Неизвестен',
  'imaging.exportInterPlaneStep': 'Расстояние между плоскостями',
  'imaging.exportMillimetres': '{value} мм',
  'imaging.exportSopClasses': 'Классы SOP',
  'imaging.exportStoredSyntaxes': 'Исходные Transfer Syntaxes',
  'imaging.exportStack': 'Пространственный стек',
  'imaging.exportStackOption': '{id} · позиций: {count}',
  'imaging.exportStackDimension': '{label}: {value}',
  'imaging.exportDimensionStack': 'Стек',
  'imaging.exportDimensionTemporal': 'Временная позиция',
  'imaging.exportDimensionEchoNumber': 'Номер эха',
  'imaging.exportDimensionEchoTime': 'Время эха',
  'imaging.exportDimensionDiffusionBValue': 'b-фактор диффузии',
  'imaging.exportSelection': 'Выбор позиций',
  'imaging.exportSelectionRange': 'Диапазон и шаг',
  'imaging.exportSelectionExact': 'Точные позиции',
  'imaging.exportFirst': 'С',
  'imaging.exportLast': 'По',
  'imaging.exportStep': 'Шаг',
  'imaging.exportRangeHint': 'Границы включительно, нумерация с единицы в порядке стека по координатам пациента; шаг 2 берёт каждую вторую позицию.',
  'imaging.exportExactPositions': 'Позиции',
  'imaging.exportExactPositionsPlaceholder': '451, 453, 457',
  'imaging.exportExactPositionsHint': 'Введите возрастающие номера позиций через запятую или пробел (1–{count}).',
  'imaging.exportRangeUnavailable': 'Порядок по координатам пациента неизвестен, поэтому серию можно экспортировать только целиком.',
  'imaging.exportCrop': 'Выделение области',
  'imaging.exportCropNone': 'Без выделения',
  'imaging.exportCropPixel': 'Прямоугольник в пикселях',
  'imaging.exportCropPatient': 'Область в координатах пациента (мм)',
  'imaging.exportLeft': 'Слева',
  'imaging.exportTop': 'Сверху',
  'imaging.exportWidth': 'Ширина',
  'imaging.exportHeight': 'Высота',
  'imaging.exportAxisMinimum': '{axis}, минимум',
  'imaging.exportAxisMaximum': '{axis}, максимум',
  'imaging.exportSegmentationRoi': 'ROI по сегментации',
  'imaging.exportSegmentationNone': 'Не применять сегментацию',
  'imaging.exportSegmentationOption': '{number} · {name}',
  'imaging.exportSegmentationMode': 'Маска сегментации',
  'imaging.exportSegmentationInclude': 'Оставить пиксели внутри сегментации',
  'imaging.exportSegmentationExclude': 'Убрать пиксели внутри сегментации',
  'imaging.exportInvalid': 'Выберите хотя бы одну серию и проверьте позиции, диапазоны и координаты области.',
  'imaging.exportSelectionInvalid': 'Выберите серию и доступную пространственную стопку. Проверьте, что выбранные позиции входят в её диапазон.',
  'imaging.exportRangeInvalid': 'Первая позиция, последняя позиция и шаг должны быть положительными целыми числами. Первая позиция не должна превышать последнюю, а последняя — число доступных позиций.',
  'imaging.exportExactInvalid': 'Введите доступные номера позиций по возрастанию, без повторов, разделяя их пробелами или запятыми.',
  'imaging.exportPixelInvalid': 'Область обрезки должна помещаться в матрице изображения. Отступы слева и сверху задаются неотрицательными целыми числами, ширина и высота — положительными целыми числами.',
  'imaging.exportPatientInvalid': 'Заполните все шесть координат в миллиметрах. Минимум каждой оси должен быть меньше максимума.',
  'imaging.exportQualityInvalid': 'Качество JPEG Baseline задаётся целым числом от 1 до 100. Для других кодировок этот параметр не используется.',
  'imaging.exportDicomdirFailed': 'Не удалось создать индекс DICOMDIR из метаданных изображений. Отключите включение индекса DICOMDIR и повторите экспорт. Если принимающему просмотрщику нужен DICOMDIR, попросите поддержку проверить метаданные исходного файла.',
  'imaging.exportCropEmpty': 'Область обрезки некорректна или не пересекается с выбранными изображениями. Проверьте границы; для обрезки в координатах пациента выберите весь диапазон позиций, чтобы кадры определялись по объёму.',
  'imaging.exportEncodingFailed': 'Выбранная кодировка несовместима с пикселями или преобразованием. Выберите вариант без сжатия — Explicit VR Little Endian — и повторите экспорт.',
  'imaging.exportDecodeFailed': 'Не удалось декодировать исходные пиксели. Попробуйте экспортировать исходные объекты целиком без перекодирования или попросите поддержку проверить файл.',
  'imaging.exportGeometryFailed': 'В исходных данных недостаточно достоверной пространственной геометрии для этой операции. Экспортируйте серию целиком в исходной структуре, без обрезки и маски сегментации.',
  'imaging.exportLayoutFailed': 'Выбранная структура DICOM несовместима с изображениями. Сохраните исходную структуру, выберите вариант без сжатия — Explicit VR Little Endian — или экспортируйте несовместимые серии отдельно.',
  'imaging.exportSegmentationFailed': 'Сегментация не совмещается с выбранными изображениями. Уберите маску или выберите сегментацию в той же системе координат.',
  'imaging.exportMediaFailed': 'Созданный пакет не прошёл проверку целостности. Повторите экспорт; если ошибка повторится, попросите поддержку проверить исходный файл. Исходные изображения не изменены.',
  'imaging.exportAsStoredUnavailable': 'Экспорт без перекодирования недоступен при изменении структуры, выборе части многофреймового объекта, обрезке или маскировании. Используется кодировка создаваемого файла.',
  'imaging.exportJpegUnavailable': 'JPEG Baseline недоступен для этих пикселей: требуются беззнаковые 8-битные изображения. Выберите доступную кодировку без потерь, чтобы сохранить значения исходных пикселей.',
  'imaging.exportPatientCropHint': 'Координаты заданы в пространстве пациента. Оставьте весь диапазон позиций, чтобы кадры выбирались по объёму. Позиции экспорта упорядочены в пространстве пациента и могут отличаться от номеров кадров в просмотрщике.',
  'imaging.exportAction': 'Экспорт',
  'imaging.exportStarting': 'Запускаем экспорт…',
  'imaging.exportQueued': 'Экспорт поставлен в очередь',
  'imaging.exportRunning': 'Создаём DICOM-пакет',
  'imaging.exportRunningHint': 'Сервер создаёт и проверяет выбранные объекты. Панель можно безопасно закрыть.',
  'imaging.exportCancel': 'Отменить экспорт',
  'imaging.exportCancelling': 'Отменяем…',
  'imaging.exportReady': 'Временный DICOM-пакет готов к скачиванию.',
  'imaging.exportDownload': 'Скачать экспорт',
  'imaging.exportFailed': 'Не удалось создать DICOM-пакет. Повторите экспорт без сжатия — Explicit VR Little Endian; если ошибка останется, попросите поддержку проверить экспорт. Исходные изображения не изменены.',
  'imaging.exportCancelled': 'Экспорт отменён, временные данные удаляются.',
  'imaging.exportExpired': 'Срок хранения временного экспорта истёк. Создайте его заново из исследования.',
  'imaging.exportStatusFailed': 'Не удалось обновить состояние экспорта. Серверное задание не изменено.',
  'imaging.exportCreateFailed': 'Не удалось запустить экспорт. Проверьте параметры и попробуйте снова.',
  'imaging.exportCancelFailed': 'Не удалось отменить экспорт. Его состояние на сервере не изменено.',
  'imaging.exportTsAsStored': 'Как сохранено — без перекодирования',
  'imaging.exportTsImplicit': 'Без сжатия — Implicit VR Little Endian',
  'imaging.exportTsExplicit': 'Без сжатия — Explicit VR Little Endian',
  'imaging.exportTsJpegBaseline': 'JPEG Baseline — с потерями, 8 бит',
  'imaging.exportTsJpegLossless': 'JPEG без потерь SV1',
  'imaging.exportTsJpegLs': 'JPEG-LS без потерь',
  'imaging.exportTsJpeg2000': 'JPEG 2000 без потерь',
  'imaging.exportTsRle': 'RLE без потерь',

  'imaging.importTitle': 'Добавить исследование',
  'imaging.importSubtitle': 'Выберите источник исследования. Строка появится в таблице сразу, а Terysling проверит источник до того, как исследование станет доступно в карте пациента.',
  'imaging.sourceLegend': 'Источник исследования',
  'imaging.sourceArchive': 'Загрузить архивы',
  'imaging.sourceArchiveDetail': 'ZIP-архивы, полученные от пациента или диагностического центра. Выберите несколько — каждый импортируется отдельно.',
  'imaging.sourceFiles': 'Выбрать папку или файлы',
  'imaging.sourceFilesDetail': 'Содержимое медицинского носителя, импортируемое как один источник; программы просмотра из комплекта будут проигнорированы.',
  'imaging.sourceRemote': 'Импортировать по ссылке',
  'imaging.sourceRemoteDetail': 'Terysling загрузит пригодный для импорта пакет исследований по HTTPS.',
  'imaging.kindArchive': 'ZIP-архив',
  'imaging.kindFiles': 'Папка или файлы',
  'imaging.kindRemote': 'Ссылка для загрузки',
  'imaging.chooseArchive': 'Выбрать ZIP-архивы',
  'imaging.chooseMoreArchives': 'Добавить ещё архивы',
  'imaging.chooseFolder': 'Выбрать папку',
  'imaging.chooseFiles': 'Выбрать файлы',
  'imaging.chosenOne': 'Выбран 1 файл',
  'imaging.chosenMany': 'Выбрано файлов: {count}',
  'imaging.chosenBytes': 'Общий объём: {size}',
  'imaging.chosenMore': 'Не показано в списке: {count}',
  'imaging.removeChosen': 'Убрать файл «{name}»',
  'imaging.fileSetLabel': 'Выбранные файлы',
  'imaging.invalidArchive': 'Выберите непустые ZIP-архивы в пределах допустимого объёма.',
  'imaging.invalidFiles': 'Выберите от 1 до 100 000 непустых файлов в пределах допустимого объёма.',
  'imaging.remoteUrl': 'Ссылка для загрузки',
  'imaging.remoteUrlPlaceholder': 'https://imaging-centre.example/download',
  'imaging.remotePassword': 'Пароль или код доступа (необязательно)',
  'imaging.remotePasswordHint': 'Секрет передаётся один раз для этого импорта и больше не отображается.',
  'imaging.invalidRemoteUrl': 'Введите корректную HTTPS-ссылку без имени пользователя и пароля в адресе.',
  'imaging.startImportOne': 'Начать импорт',
  'imaging.startImportMany': 'Начать импорты: {count}',

  'imaging.phase.starting': 'Запуск…',
  'imaging.phase.transferring': 'Передача',
  'imaging.phase.checking': 'Проверка',
  'imaging.phase.review': 'Готово к сохранению',
  'imaging.phase.saving': 'Сохранение',
  'imaging.phase.interrupted': 'Передача прервана',
  'imaging.phase.refused': 'Импорт отклонён',
  'imaging.transportProgress': 'Передано: {percent}%',
  'imaging.transportRetry': 'Возобновить загрузку',
  'imaging.transportRetryNamed': 'Возобновить загрузку источника «{name}»',
  'imaging.transportRetrying': 'Возобновление…',
  'imaging.reselectSource': 'Выбрать источник снова',
  'imaging.reselectSourceNamed': 'Повторно выбрать исходные файлы для «{name}»',
  'imaging.restartImport': 'Начать заново',
  'imaging.restartImportNamed': 'Начать импорт источника «{name}» заново',
  'imaging.restartRemoteTitle': 'Скачать источник заново?',
  'imaging.restartRemoteDetail': 'Terysling хранит адрес, а не саму загрузку, поэтому начнётся новый импорт с того же адреса, а отклонённый будет отменён. Пароль запрашивается снова, потому что он был передан один раз и в этом браузере не хранится.',
  'imaging.restartRemoteKeep': 'Оставить отклонённый импорт',
  'imaging.importRefreshFailed': 'Не удалось обновить состояние импорта. Импорт по-прежнему хранится в Terysling.',
  'imaging.uploadLedgerFailed': 'Не удалось обновить список загрузок. Уже известные строки остаются видимыми.',
  'imaging.saveStudy': 'Сохранить исследование',
  'imaging.saveStudyNamed': 'Сохранить «{name}»',
  'imaging.cancelUploadNamed': 'Отменить загрузку источника «{name}»',
  'imaging.cancelUploadTitle': 'Отменить эту загрузку?',
  'imaging.cancelUploadDetail': 'Загрузка остановится, доступ к ней будет отозван, резерв места освобождён, а временные данные поставлены на удаление. После этого строка исчезнет из всех списков загрузок.',
  'imaging.cancelUploadKeep': 'Продолжить загрузку',
  'imaging.cancelUploadConfirm': 'Отменить загрузку',
  'imaging.cancelUploadFailed': 'Не удалось отменить загрузку. Она остаётся видимой, никакая работа не скрыта.',
  'imaging.uploadsUnfinished': 'Незавершённые загрузки: продолжаются — {continuing}, ждут повторного выбора источника — {paused}, ждут подтверждения — {confirmation}, отклонены — {refused}.',
  'imaging.uploadsUnfinishedDismiss': 'Закрыть',

  'imaging.detectedCountOne': 'Обнаружено 1 исследование',
  'imaging.detectedCountMany': 'Обнаружено исследований: {count}',
  'imaging.previewTitle': 'Проверка обнаруженных исследований',
  'imaging.previewDetail': 'Приведённые ниже данные пациента из DICOM служат только сведениями об источнике. Они никогда не меняют выбранного пациента Terysling.',
  'imaging.targetPatient': 'Целевой пациент Terysling',
  'imaging.sourcePatient': 'Данные пациента в DICOM',
  'imaging.identityComparison': 'Сопоставление данных пациента',
  'imaging.patientName': 'Имя',
  'imaging.patientId': 'Идентификатор пациента',
  'imaging.patientBirthDate': 'Дата рождения',
  'imaging.patientSex': 'Пол',
  'imaging.notRecorded': 'Не указано',
  'imaging.studySelect': 'Импортировать «{name}»',
  'imaging.studyDescription': 'Описание',
  'imaging.studyBodyPart': 'Область тела',
  'imaging.studySource': 'Организация-источник',
  'imaging.studyDate': 'Дата исследования',
  'imaging.studySeries': 'Серии',
  'imaging.studyImages': 'Изображения',
  'imaging.demographicMismatchTitle': 'Данные пациентов не совпадают',
  'imaging.demographicMismatchDetail': 'Внимательно проверьте обе личности. Импортируйте исследование, только если оно принадлежит выбранному пациенту.',
  'imaging.demographicMismatchConfirm': 'Я проверил(а), что выбранные исследования принадлежат этому пациенту',
  'imaging.confirm': 'Сохранить выбранные исследования',
  'imaging.confirming': 'Сохранение…',
  'imaging.confirmSelectionRequired': 'Выберите хотя бы одно поддерживаемое исследование.',
  'imaging.confirmMismatchRequired': 'Перед импортом подтвердите проверку несовпадающих данных пациента.',
  'imaging.confirmFailed': 'Не удалось подтвердить импорт. Предварительный просмотр обновлён — проверьте его и повторите попытку.',
  'imaging.confirmStale': 'Пока панель была открыта, предварительный просмотр изменился и только что обновлён. Проверьте, что отмечено сейчас, и сохраните снова.',
  'imaging.confirmNotConfirmable': 'Этот импорт больше не ждёт подтверждения — он уже сохранён, отменён или отклонён. Обновлённый просмотр показывает, что именно.',
  'imaging.confirmSelectionRefused': 'Выбранные исследования отклонены. Предварительный просмотр обновлён; выберите из тех исследований, которые он показывает сейчас.',
  'imaging.confirmQuota': 'Сохранение этих исследований превысит хранилище изображений клиники. Сохраните меньше исследований или сначала освободите место.',
  'imaging.confirmMismatchRefused': 'В импорте есть расхождение в данных пациента, которого не показывал этот просмотр. Он обновлён — прочитайте сравнение снова и подтвердите расхождение.',
  'imaging.confirmForbidden': 'У этой учётной записи нет права сохранять исследования. Ничего не сохранено.',
  'imaging.confirmGone': 'Этот импорт больше не доступен. Ничего не сохранено.',
  'imaging.confirmUnavailable': 'Хранилище изображений не ответило. Ничего не сохранено, попытку стоит повторить.',
  'imaging.dicomUidCollision': 'Это исследование уже закреплено за пациентом {displayName} ({patientCode}).',

  'imaging.deleteSelected': 'Удалить выбранное: {count}',
  'imaging.aiUnavailableForStudies':
    'ИИ-инструменты пока не читают исследования. Обработка охватит только выбранные документы.',
  'imaging.deleteTitle': 'Удалить выбранное?',
  'imaging.deleteStudiesTitle': 'Размещённые исследования — удаляются безвозвратно',
  'imaging.deleteStudiesDetail': 'Доступ к просмотру будет отозван, а архив поставлен в очередь на безвозвратное удаление. Отменить это нельзя.',
  'imaging.deleteQueuedTitle': 'Текущие импорты — отменяются во всём приложении',
  'imaging.deleteQueuedDetail': 'Передача и обработка остановятся, доступ к загрузке будет отозван, резерв места освобождён, а временные данные поставлены на удаление.',
  'imaging.deleteKeep': 'Оставить',
  'imaging.deleteConfirm': 'Удалить',
  'imaging.deleting': 'Удаление…',
  'imaging.deleteFailed': 'Не удалось завершить удаление. Кроме уже удалённых исследований ничего не удалено.',

  'imaging.compatibility.pending': 'Ожидает проверки совместимости',
  'imaging.compatibility.supported': 'Поддерживается',
  'imaging.compatibility.warning': 'Поддерживается с предупреждением',
  'imaging.compatibility.unsupported': 'Не поддерживается',
  'imaging.issue.unsupportedModality': 'Объекты с неподдерживаемым типом исследования пропущены.',
  'imaging.issue.unsupportedSopClass': 'Неподдерживаемые типы объектов DICOM пропущены.',
  'imaging.issue.unsupportedTransferSyntax': 'Изображения с неподдерживаемым кодированием пропущены.',
  'imaging.issue.unsupportedMultiframe': 'Неподдерживаемые многокадровые объекты пропущены.',
  'imaging.issue.nonDicomFilesIgnored': 'Файлы, не относящиеся к DICOM, проигнорированы.',
  'imaging.issue.encryptedArchiveUnsupported': 'ZIP-архивы с паролем нельзя импортировать.',
  'imaging.issue.burnedInAnnotation': 'Изображения могут содержать данные пациента, нанесённые непосредственно на пиксели.',
  'imaging.issue.lossyCompression': 'Источник содержит изображения со сжатием с потерями.',
  'imaging.issue.demographicMismatch': 'Данные пациента в источнике отличаются от выбранного пациента.',
  'imaging.issue.other': 'Средство проверки сообщило предупреждение о совместимости.',
  'imaging.issueWithCount': '{issue} ({count})',
  'imaging.failure.remoteNotImportable': 'Эта ссылка открывает веб-просмотр, но не предоставляет пакет исследований для загрузки.',
  'imaging.failure.remoteForbidden': 'Адрес ссылки запрещён для безопасного удалённого импорта.',
  'imaging.failure.remoteUnavailable': 'Удалённый источник остался недоступен после повторных попыток. Проверьте ссылку и доступность источника, затем запустите импорт снова.',
  'imaging.failure.unsafeArchive': 'Архив отклонён из-за небезопасной структуры или распакованного объёма.',
  'imaging.failure.encryptedArchiveUnsupported': 'ZIP-архивы с паролем нельзя импортировать. Снимите пароль и повторите попытку.',
  'imaging.failure.noDicom': 'В предоставленном источнике не найдено читаемое исследование DICOM.',
  'imaging.failure.mixedIdentity': 'Источник содержит несколько личностей пациентов, поэтому их нельзя импортировать вместе.',
  'imaging.failure.unsupportedDicom': 'Выбранное исследование не входит в поддерживаемый контракт совместимости DICOM.',
  'imaging.failure.duplicateImages': 'Источник содержит повторяющиеся идентификаторы изображений.',
  'imaging.failure.inconsistentSeries': 'Источник содержит противоречивые метаданные серии и не может быть безопасно импортирован.',
  'imaging.failure.tooLarge': 'Источник превышает настроенные ограничения импорта исследований.',
  'imaging.failure.generic': 'Не удалось импортировать источник исследований. Повторите попытку или попросите администратора проверить сервис.',
}
